import { render } from "./Priorities.vue?vue&type=template&id=14a97410&scoped=true"
import script from "./Priorities.vue?vue&type=script&lang=js"
export * from "./Priorities.vue?vue&type=script&lang=js"

import "./Priorities.vue?vue&type=style&index=0&id=14a97410&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a97410"]])

export default __exports__